import React from 'react'
import LocalShipping from '@mui/icons-material/LocalShipping';
import ProductHierarchyHierarchyList from './HierarchyList';
import ProductHierarchyFlatList from './FlatList';
import FlatEdit from './FlatEdit';
import ProductHierarchyList from './HierarchyList';
import HierarchyEdit from './HierarchyEdit';
import Create from './Create'

//true
const isHierarchy = true; // expects true or false injected by plop

const listComponent = isHierarchy
  ? ProductHierarchyHierarchyList
  : ProductHierarchyFlatList;


const editComponent = isHierarchy
  ? HierarchyEdit
  : FlatEdit;

const conf = {
    name: 'lil_drug_product_hierarchy',
    icon: <LocalShipping />,
    list: listComponent,
    edit: editComponent,
    create: Create,
    options: {
        label: "Product Hierarchy",
        items: true
    }
};

export default conf;